export { AtnDsAccordionComponent as Component } from './accordion.component'
